export { default as ErrorFloat, CN_ERROR_FLOAT_SVG } from './Float/component'
export { default as ErrorField } from './Field/component'
export { default as ErrorPage } from './Page/component'
